/* eslint no-async-promise-executor: 0 */
import api from "@/services/vex/api";

async function autenticacao(token, email, senha/*, tokenCaptcha*/) {
    if (token && email && senha/* && tokenCaptcha*/) {
        try {
            let uri = "/usuarios/v1/usuario/autenticar";
            let params = {
                token: token,
                email: email,
                senha: senha,
                //token_captcha: tokenCaptcha,
                aplicativo: "web.vexsoft.com.br"
            };
    
            const result = await api.post(uri, params);
            return result.data[0] ?? null;
        } catch (error) {
            if (error.response) throw error.response.data;
            else throw error;
        }
    } else {
        throw new Error("Preencha todos os dados obrigatórios");
    }
}

export default autenticacao;
